import { render, staticRenderFns } from "./initiateDetail.vue?vue&type=template&id=39e0b582&scoped=true"
import script from "./initiateDetail.vue?vue&type=script&lang=js"
export * from "./initiateDetail.vue?vue&type=script&lang=js"
import style0 from "./initiateDetail.vue?vue&type=style&index=0&id=39e0b582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e0b582",
  null
  
)

export default component.exports